export const getGalleryBumpTimestamps = (offsetMs = 0) => {
  const creationTime = Date.now() + offsetMs;
  return {
    creationTime,
    creationTimeNegative: -creationTime,
  };
};

export const bumpGalleryItemToFront = (items, itemId, patch = {}) => {
  if (!Array.isArray(items) || !itemId) {
    return items;
  }

  const itemIndex = items.findIndex((entry) => entry?.id === itemId);
  if (itemIndex === -1) {
    return items;
  }

  const timestamps =
    patch.creationTime != null && patch.creationTimeNegative != null
      ? {
          creationTime: patch.creationTime,
          creationTimeNegative: patch.creationTimeNegative,
        }
      : getGalleryBumpTimestamps();

  const updatedItem = {
    ...items[itemIndex],
    ...patch,
    ...timestamps,
  };

  return [
    updatedItem,
    ...items.slice(0, itemIndex),
    ...items.slice(itemIndex + 1),
  ];
};

export const applyGalleryReorderPreservingPlaceholders = (
  items,
  reorderRestFn
) => {
  if (!Array.isArray(items)) {
    return items;
  }

  const placeholders = items.filter((item) => item?.resizingFormat);
  const rest = items.filter((item) => !item?.resizingFormat);
  return [...placeholders, ...reorderRestFn(rest)];
};

export const bumpGalleryItemsToFront = (items, updates = []) => {
  if (!Array.isArray(items) || updates.length === 0) {
    return items;
  }

  let result = items;
  for (let index = 0; index < updates.length; index += 1) {
    const { id, patch = {} } = updates[index];
    const timestamps = getGalleryBumpTimestamps(updates.length - index);
    result = bumpGalleryItemToFront(result, id, { ...patch, ...timestamps });
  }

  return result;
};

export const getGalleryItemHighlightKeys = (item) => {
  const keys = [];
  if (item?.id != null) {
    keys.push(String(item.id));
  }
  if (item?.stableKey) {
    keys.push(String(item.stableKey));
  }
  if (item?.url) {
    keys.push(String(item.url));
  }
  return keys;
};
